module.exports = __webpack_public_path__ + "img/price-tag.3ca02815.svg";